import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { EditAssignmentDialogModule } from '../../components/edit-assignment-dialog/edit-assignment-dialog.module';
import { CompassTabComponent } from './compass-tab.component';
import { MatIconModule } from '@angular/material/icon';
import { DocumentsDialogModule  } from '../../components/documents/documents-dialog.module';
import { AssessmentModule } from '../assessment/assessment.module';

import { LoggingDetailDialogModule } from '../logging-detail-dialog/logging-detail-dialog.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        AssessmentModule,
        CommonModule,
        DocumentsDialogModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        EditAssignmentDialogModule,
        LoggingDetailDialogModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        MatTooltipModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        CompassTabComponent,
    ],
    exports: [
        CompassTabComponent
    ]
})
export class CompassTabModule { }
